import React, { useEffect } from 'react';
import { hideSplash } from '../lib/splash';

/**
 * Bekleyen ya da kayıtsız alan adında sitenin yerine çizilen ekran (26.10.2026).
 *
 * Ortak Alan Adları'nda Sıradaki/Sonrakiler aşamasındaki ya da hiç kayıtlı
 * olmayan bir adrese gelen ziyaretçi siteyi görmez: sunucu 404 +
 * `DOMAIN_NOT_FOUND` döner (backend services/domain_gate.py). Ekran bilinçli
 * olarak **markasızdır** — logo, site adı ya da tema rengi yok: bekleyen adres
 * hangi siteye ait olduğunu ele vermez. Arama motorları dizine almasın diye
 * `noindex` yazılır.
 */
const DomainNotFoundScreen = () => {
  useEffect(() => {
    hideSplash();
    document.title = 'Alan adı bulunamadı';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);

  return (
    <main
      data-testid="domain-not-found"
      style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', padding: '24px 16px', background: '#f5f5f5', color: '#222',
        fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif', textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: 22, fontWeight: 600, margin: 0 }}>Alan adı bulunamadı</h1>
      <p style={{ fontSize: 14, color: '#666', margin: '10px 0 0' }}>
        Bu adreste yayında bir site yok.
      </p>
    </main>
  );
};

export default DomainNotFoundScreen;
